export const socialsData = {
    github: 'https://github.com/ilshin714',
    linkedIn: 'https://www.linkedin.com/in/iji',
    youtube: 'https://www.youtube.com/@ilshinji157'
}